import { render, staticRenderFns } from "./Bando28Fase1.vue?vue&type=template&id=5b59da9e&scoped=true"
import script from "./Bando28Fase1.vue?vue&type=script&lang=js"
export * from "./Bando28Fase1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b59da9e",
  null
  
)

export default component.exports